import { useState, useDeferredValue, memo, useCallback } from 'react';
import { Flex, Box, useDisclosure, Button } from '@chakra-ui/react';
import { ChevronDownIcon } from '@chakra-ui/icons';
import { useRouter } from 'next/router';
import { useSearchParams } from 'next/navigation';

const HEIGHT = {
  xs: '24px',
  sm: '32px',
  md: '40px',
  lg: '48px',
};
const PADDING = {
  xs: '0 8px',
  sm: '0 12px',
  md: '0 16px',
  lg: '0 20px',
};

const List = memo(function List({ options = [], filter, onChange, value }) {
  const filteredOptions =
    value || filter === '系統自動選位'
      ? options
      : options.filter((option) => {
          const isMatched =
            option.name.includes(filter) || option.space_name.includes(filter);
          return isMatched;
        });

  return (
    <Flex
      pos='absolute'
      bg='white'
      direction='column'
      zIndex={1009}
      border='1px solid'
      borderColor='gray.200'
      borderRadius={4}
      width='100%'
      top='calc(100% + 8px)'
      left={0}
      maxH={200}
      overflowX='hidden'
      overflowY='auto'>
      <Box
        onClick={() => {
          onChange({
            text: '系統自動選位',
            value: options[0].slug,
          });
        }}
        borderRadius={4}
        fontSize='14px'
        px={4}
        py={2}
        _hover={{
          bg: 'gray.100',
        }}>
        系統自動選位
      </Box>
      {filteredOptions.map((option) => (
        <Box
          key={option.slug}
          onClick={() => {
            onChange({
              text: `${option.name} - ${option.space_name}`,
              value: option.slug,
            });
          }}
          borderRadius={4}
          fontSize='14px'
          px={4}
          py={2}
          _hover={{
            bg: 'gray.100',
          }}>
          {`${option.name} - ${option.space_name}`}
        </Box>
      ))}
    </Flex>
  );
});

const SelectProductPane = ({ size = 'md', options = [], onModelClose }) => {
  const height = HEIGHT[size];
  const padding = PADDING[size];
  const searchParams = useSearchParams();
  const queryString = searchParams.toString();

  const {
    isOpen: isOpenList,
    onClose: onCloseList,
    onOpen: onOpenList,
    onToggle: onToggleList,
  } = useDisclosure();

  const router = useRouter();

  const [input, setInput] = useState('系統自動選位');
  const deferredInput = useDeferredValue(input, { timeoutMs: 300 });

  const [slug, setSlug] = useState(
    options[Math.floor(Math.random() * options.length)].slug,
  );

  const handleInputChange = (e) => {
    setInput(e.target.value);
  };
  const handleSelectOption = useCallback(
    (option) => {
      setInput(option.text);
      setSlug(option.value);
      onCloseList();
    },
    [onCloseList],
  );

  return (
    <>
      <Flex
        pos='relative'
        alignItems='center'
        border='1px solid rgb(226, 232, 240)'
        borderRadius='2px'
        cursor='pointer'
        onClick={onToggleList}
        padding={padding}
        h={height}>
        <input
          type='text'
          onClick={(e) => {
            e.stopPropagation();
            onOpenList();
          }}
          onFocus={onOpenList}
          value={input}
          onChange={handleInputChange}
          style={{
            flex: 1,
            outline: 0,
            border: 0,
            appearance: 'none',
            cursor: 'pointer',
          }}
        />
        <ChevronDownIcon color='gray.400' />
        {isOpenList && (
          <List
            filter={deferredInput}
            value={slug}
            options={options}
            onChange={handleSelectOption}
          />
        )}
      </Flex>
      <Flex py={4} justifyContent='end'>
        <Button
          size='md'
          onClick={() => {
            if (slug) {
              onModelClose();
              router.push(
                `/subscribe/${slug}${queryString ? `?${queryString}` : ''}`,
              );
            }
          }}
          bg='primary.blue'
          color='white'
          _hover={{
            bg: 'primary.darkblue',
          }}>
          確認
        </Button>
      </Flex>
    </>
  );
};

export default SelectProductPane;
